import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

$(document).ready(function () {
    $('.highlight-console').each(function () {
        addCopy($(this))
    });

    $('.highlight-xml').each(function () {
        addCopy($(this))
    });

    $('.confl_code_parent').each(function () {
        addCopy($(this), '.confl_code')
    });

    function addCopy(container, child='.highlight'){
        const copyButton = $('<button>')
            .text('Копировать')
            .addClass('copy-button');
        const childContainer = container.find(child);
        if (childContainer.length === 0) {
            console.warn(`Элемент ${child} не найден`);
            return;
        }

        copyButton.on('click', function () {
            const textToCopy = childContainer.text(); // Получаем весь текст из .myContainerChild
            if (!textToCopy) {
                // alert("В блоке нет текста для копирования"); // Обрабатываем случай, если внутри ничего нет
                return;
            }

            const tempInput = $('<textarea/>')
                .val(textToCopy)
                .css('position', 'absolute') // Скрываем textarea
                .css('left', '-9999px') // Скрываем textarea
                .css('top', '-9999px')
                .appendTo('body');
            tempInput[0].select();
            document.execCommand('copy');
            tempInput.remove();

            childContainer.addClass("highlightText");
            setTimeout(function() {
                childContainer.removeClass("highlightText");
            }, 1000);
        });
        container.prepend(copyButton);
    }

    tippy('.copy-button', {
        content: 'Скопировано с буфер обмена',
        trigger: 'click'
    });


});



